/**
 * UI state store using Zustand
 */

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UiState {
  isDarkMode: boolean;
  sidebarCollapsed: boolean;
  toggleDarkMode: () => void;
  toggleSidebar: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
}

const uiStoreCreator = persist<UiState>(
  (set) => ({
    isDarkMode: false,
    sidebarCollapsed: false,

    toggleDarkMode: () => set((state) => ({ isDarkMode: !state.isDarkMode })),

    toggleSidebar: () =>
      set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),

    setSidebarCollapsed: (collapsed: boolean) =>
      set({ sidebarCollapsed: collapsed }),
  }),
  {
    name: 'tenant-ui',
  }
)

export const useUiStore = create(uiStoreCreator)

// Expose to window for shared components
declare global {
  interface Window {
    __INTELLIMON_UI_STORE__?: typeof useUiStore;
  }
}

if (typeof window !== 'undefined') {
  window.__INTELLIMON_UI_STORE__ = useUiStore
}
